import { render, staticRenderFns } from "./reservationModel.vue?vue&type=template&id=0565ace6&lang=pug&"
import script from "./reservationModel.vue?vue&type=script&lang=js&"
export * from "./reservationModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports